/**
 * Mixin for mobile-optimized table headers
 * - Removes "r_b" (row number) column on mobile
 * - Replaces "total" text with "Σ" symbol on mobile
 */
export default {
  methods: {
    /**
     * Transforms headers for mobile display
     * @param {Array} headers - Array of header objects
     * @returns {Array} - Transformed headers for current device
     */
    getMobileHeaders(headers) {
      if (!this.device.isMobile) {
        return headers;
      }

      return headers
        .filter((header) => header.value !== "num") // Remove row number column
        .map((header) => {
          if (header.value === "total") {
            return { ...header, text: "Σ" };
          }
          return header;
        });
    },
  },
};
